import * as fileSchema from './fileSchema';
import { ATTACHMENT_MAX_FILE_SIZE_BYTES } from '@/constants/uploadLimits';

// export const stepFileHelper = fileSchema.fileSchemaHelper;
// export const stepFileSchema = fileSchema
//   .createFileSchema({
//     acceptedFileTypes: [
//       'application/pdf',
//       'application/step',
//       'application/x-step',
//       'model/step',
//     ],
//   })
//   .optional();

export const pdfFileHelper = fileSchema.fileSchemaHelper;
export const pdfFileArraySchema = fileSchema.createFileSchema({
  fileType: 'pdf',
  maxFileSize: ATTACHMENT_MAX_FILE_SIZE_BYTES, // 100 MB
  maxFiles: 300,
  minFiles: 1,
  required: true,
});

export const pdfFileSchema = fileSchema.createFileSchema({
  fileType: 'pdf',
  maxFileSize: ATTACHMENT_MAX_FILE_SIZE_BYTES, // 100 MB
  required: true,
  minFiles: 1,
  maxFiles: 1,
});
